import React from "react";
import { useTranslation } from "react-i18next";

import { Button, Popconfirm } from "antd";

import { DeleteOutlined } from "@ant-design/icons";

import { API_URL } from "../../shared/utils/Util";
import { DeleteTableResponse } from "../../types/api";
import { Table } from "../../types/model";
import { fetchT } from "../../shared/utils/TypedUtil";
import { useNotification } from "../../shared/hooks";

type TableDeleteButtonProps = {
  restaurantId: string;
  table: Table;
  onSuccess: () => void;
};

export const TableDeleteButton = (props: TableDeleteButtonProps) => {
  const { t } = useTranslation();
  const { deleteSuccess, genericError } = useNotification();
  const [visible, setVisible] = React.useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = React.useState<boolean>(false);

  const showPopconfirm = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setConfirmLoading(true);

    fetchT<DeleteTableResponse>(
      "DELETE",
      `${API_URL}/v1/r/${props.restaurantId}/tables/${props.table.id}`,
      {},
      (result: DeleteTableResponse) => {
        props.onSuccess();
        deleteSuccess("table");
        setConfirmLoading(false);
        setVisible(false);
      },
      (err: any) => {
        setConfirmLoading(false);
        setVisible(false);
        genericError();
      }
    );
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Popconfirm
      title={t("delete_table_confirm", { name: props.table.name })}
      open={visible}
      onConfirm={handleOk}
      okButtonProps={{ loading: confirmLoading }}
      onCancel={handleCancel}
    >
      <Button shape="circle" danger icon={<DeleteOutlined />} onClick={showPopconfirm} />
    </Popconfirm>
  );
};
